module.exports = __webpack_public_path__ + "img/9-1.37329a59.jpg";